module.exports = __webpack_public_path__ + "media/images/icon__predict-77bda7888d544dcc011e843c0ce256b1.png";